module.exports = __webpack_public_path__ + "static/img/48070.d97bc99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48070.jpg
// module id = H4S2
// module chunks = 1